// Stored-procedure debugger API client (admin). Drives an interactive debug
// session: start → poll state → step/continue/breakpoints → stop.
import { api } from './api.js';

export const startSPDebug       = (body)         => api.post('/api/tools/sp-debug/start', body);
export const spDebugState       = (token)        => api.get(`/api/tools/sp-debug/${token}/state`);
export const spDebugStep        = (token)        => api.post(`/api/tools/sp-debug/${token}/step`);
export const spDebugContinue    = (token)        => api.post(`/api/tools/sp-debug/${token}/continue`);
export const spDebugBreakpoints = (token, lines) => api.post(`/api/tools/sp-debug/${token}/breakpoints`, { lines });
export const spDebugStop        = (token)        => api.post(`/api/tools/sp-debug/${token}/stop`);
export const spDebugResultSets  = (token)        => api.get(`/api/tools/sp-debug/${token}/resultsets`);
export const spDebugExec        = (token, sql)   => api.post(`/api/tools/sp-debug/${token}/exec`, { sql });

// parseProcParams extracts a procedure's parameters from its CREATE text (for
// the pre-start args dialog). Best-effort — the backend re-parses authoritatively.
export function parseProcParams(sql) {
  const s = String(sql || '');
  const open = s.search(/\bprocedure\b/i);
  if (open < 0) return [];
  const paren = s.indexOf('(', open);
  if (paren < 0) return [];
  // Balance parens to find the param list end.
  let depth = 0, end = -1;
  for (let i = paren; i < s.length; i++) {
    if (s[i] === '(') depth++;
    else if (s[i] === ')') { depth--; if (depth === 0) { end = i; break; } }
  }
  if (end < 0) return [];
  const inner = s.slice(paren + 1, end);
  if (!inner.trim()) return [];
  // Split on top-level commas (types like DECIMAL(10,2) have nested commas).
  const parts = [];
  let buf = '', d = 0;
  for (const ch of inner) {
    if (ch === '(') d++;
    if (ch === ')') d--;
    if (ch === ',' && d === 0) { parts.push(buf); buf = ''; } else buf += ch;
  }
  if (buf.trim()) parts.push(buf);
  return parts.map((p) => {
    const toks = p.trim().split(/\s+/);
    let mode = 'IN';
    if (/^(IN|OUT|INOUT)$/i.test(toks[0])) mode = toks.shift().toUpperCase();
    const name = (toks.shift() || '').replace(/`/g, '');
    return { mode, name, type: toks.join(' ') };
  }).filter((p) => p.name);
}
